module.exports = __webpack_public_path__ + "static/media/ev-catalog-screenshot.b7895cbc.png";